export default "__VITE_ASSET__CmBuLhjv__"